<template>
  <span :class="primitiveBaseClasses">
  <div style="position:relative">
    <label class="amf-input-label" v-if="$_showLabel">{{label}}</label>
    <!-- Apologies for the duplication here. There wasn't an elegant way to dynamically add the `.lazy`
         directive to an input.


         For now any items need to go in both input lines below. Feel free to make this less unpleasant.-->
      <div class="input-group">
        <input v-if="aggressive" :class="['form-control', { error: hasError }]" :type="inputType" :maxlength="maxLength" v-on:keydown="keyMonitor" v-on:input="onInput"
               v-model="internalValue" :autocomplete="autocomplete" :placeholder="placeholder" :title="title || label" :autofocus="$_autofocus" :disabled="$_disabled" :readonly="readonly"  />
        <input v-else :class="['form-control', { error: hasError }]" :type="inputType" :maxlength="maxLength" v-on:keydown="keyMonitor" v-on:input="onInput"
               v-model.lazy="internalValue" :autocomplete="autocomplete" :placeholder="placeholder" :title="title || label" :autofocus="$_autofocus" :disabled="$_disabled" :readonly="readonly"  />
        <div v-if="showCopyButton" class="input-group-append" @click="copyValue">
          <span class="input-group-text">
              <span class="fa fa-clipboard"></span>
          </span>
        </div>
        <div v-if="details && details.length > 0" class="input-group-append" @click="toggleDetails">
          <span class="input-group-text">
              <span :class="detailsIcon"></span>
          </span>
        </div>
      </div>
  
      <div v-if="detailsVisible && details && details.length > 0" class="details-container">
        <div v-for="(details, index) in details" :key="index" class="details-item">
          <span>{{ details.label }}</span>
        </div>
      </div>
  
      <div class="error-div">
        {{validationMessage}}
      </div>
  </div>
  
  </span>
  </template>
  
  <script>
  import primitiveMixin from './primitive-mixin'
  import { v } from "framework";
  import Vue from 'vue';
  import VueClipboard from 'vue-clipboard2';
  Vue.use(VueClipboard);
  
  export default {
      mixins: [primitiveMixin],
      props: {
          label: String,
          value: {},
          aggressive: { type: Boolean, default: false },
          title: { type: String, required: false },
          maxLength: { type: Number, required: false },
          inputType: { type: String, default: 'text' },
          autocomplete: { type: String, default: null },
          readonly: {type: Boolean, default: false},
          showCopyButton: { type: Boolean, default: false },
          decimalPlaces: { type: Number, required: false, default: 2 },
          details: { type: Array, default: () => [] },
          detailsIcon: { type: String, required: false, default: 'fa fa-question-circle' }
      },
      data() {
          return {
              internalValue: this.value && this.value.$model ? this.getInternalVal(this.value.$model) : this.getInternalVal(this.value),
              detailsVisible: false
          }
      },
      watch: {
          value(newValue) {
              this.internalValue = newValue;
          },
          internalValue(newValue) {
              this.changeMade({
                  name: this.label,
                  value: this.internalValue
              });
              if (newValue === "" || newValue === null) {
                  this.$emit("input", null);
              } else {
                  this.$emit("input", (this.isNumber() && newValue !== '.') ? Number(newValue) : newValue);
              }
          },
      },
      methods: {
          isNumber() {
              if (!this.validator) return false;
              return v.isNumberValidator(this.validator);
          },
          getInternalVal(val){
              return this.isMoney(val) ? this.preventDecimalTruncation(val) : val;
          },
          isMoney(val){
              return this.isNumber() && val && val.toString().indexOf(".") != -1;
          },
          preventDecimalTruncation(val){
              return parseFloat(val).toFixed(this.decimalPlaces);
          },
          onInput(event) {
            var value = event.target.value;
            if(value && this.inputType == 'number' && this.maxLength) {
                event.target.value = event.target.value.slice(0, this.maxLength);
            }
          },
          keyMonitor(event) {
              if (this.isNumber()) {
                  const validKeyCodes = [8,9,35,36,37,39,46,48,49,50,51,52,53,54,55,56,57,96,97,98,99,100,101,102,103,104,105,110,190];
                  if (validKeyCodes.indexOf(event.keyCode) === -1) {
                      event.preventDefault();
                  } else {
                      const validKeys = [
                        'Backspace', //8
                        'Tab', //9
                        'End', //35
                        'Home', //36
                        'ArrowLeft', //37
                        'ArrowRight', //39
                        'Delete', //46
                        '0', //48, 96
                        '1', //49, 97
                        '2', //50, 98
                        '3', //51, 99
                        '4', //52, 100
                        '5', //53, 101
                        '6', //54, 102
                        '7', //55, 103
                        '8', //56, 104
                        '9', //57, 105
                        '.', //110, 190
                      ]
                      if (validKeys.indexOf(event.key) === -1) {
                          event.preventDefault();
                      }
                  }
              }
          },
          copyValue(){
            this.$copyText(this.value).then(() => {
              toastService.success(`Copied ${this.label} to clipboard`);
            }, () => {
              toastService.error(`Error copying ${this.label} to clipboard`);
            });
          },
          toggleDetails() {
              this.detailsVisible = !this.detailsVisible;
          },
          handleClickOutsideDetails(e) {
              if (!this.$el.contains(e.target)) {
                  this.detailsVisible = false;
              }
          }
      },
      mounted() {
          document.addEventListener('click', this.handleClickOutsideDetails);
      },
  }
  </script>
  
  <style lang="scss" scoped>
      /* Chrome, Safari, Edge, Opera */
      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
      }
  
      /* Firefox */
      input[type=number] {
          -moz-appearance: textfield;
      }
  
      .input-group-append {
        cursor: pointer;
      }

      .details-container {
        margin-left: 0.5rem;
        position: absolute;
        background-color: rgb(238, 238, 238);
        border: 1px solid rgb(207, 207, 207);
        white-space: nowrap;
        overflow-y: auto;
        z-index: 1000;
      }
  
      .details-item {
        padding-left: 1rem;
        padding-right: 1rem;
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
        border: 1px solid transparent;
        color: black;
        .fa {
            margin-right: 1rem;
            color: gray;
        }
      }
  </style>
  


// WEBPACK FOOTER //
// src/framework/primitives/AmfInput.vue